/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/+root'
import { Route as Char43indexRouteImport } from './pages/+index'
import { Route as Char43authRouteImport } from './pages/+auth'
import { Route as demoChar43routeRouteImport } from './pages/demo/+route'
import { Route as forgotPasswordChar43routeRouteImport } from './pages/forgot-password/+route'
import { Route as newAccountChar43routeRouteImport } from './pages/new-account/+route'
import { Route as nominateChar43routeRouteImport } from './pages/nominate/+route'
import { Route as signInChar43routeRouteImport } from './pages/sign-in/+route'
import { Route as appChar43routeRouteImport } from './pages/(app)/+route'
import { Route as mergeAccountChar43routeRouteImport } from './pages/merge-account/+route'
import { Route as giftActivateChar43routeRouteImport } from './pages/gift/activate/+route'
import { Route as invitationActivateChar43routeRouteImport } from './pages/invitation/activate/+route'
import { Route as policiesTermsChar43routeRouteImport } from './pages/policies/terms/+route'
import { Route as appClaimsChar43routeRouteImport } from './pages/(app)/claims/+route'
import { Route as appEapChar43routeRouteImport } from './pages/(app)/eap/+route'
import { Route as appFavouritesIndexRouteImport } from './pages/(app)/favourites/index'
import { Route as appHomeIndexRouteImport } from './pages/(app)/home/index'
import { Route as appMessagesChar43routeRouteImport } from './pages/(app)/messages/+route'
import { Route as appPurchasesChar43routeRouteImport } from './pages/(app)/purchases/+route'
import { Route as appResourcesChar43routeRouteImport } from './pages/(app)/resources/+route'
import { Route as appSettingsChar43routeRouteImport } from './pages/(app)/settings/+route'
import { Route as appTopUpChar43routeRouteImport } from './pages/(app)/top-up/+route'
import { Route as appWalletChar43routeRouteImport } from './pages/(app)/wallet/+route'
import { Route as appClaimsChar43indexRouteImport } from './pages/(app)/claims/+index'
import { Route as appClaimsChar91claimIdChar93Char43routeRouteImport } from './pages/(app)/claims/[claimId]/+route'
import { Route as appClaimsHelpChar43routeRouteImport } from './pages/(app)/claims/help/+route'
import { Route as appClaimsNewChar43routeRouteImport } from './pages/(app)/claims/new/+route'
import { Route as appClaimsPolicyChar43routeRouteImport } from './pages/(app)/claims/policy/+route'
import { Route as appClaimsSetupChar43routeRouteImport } from './pages/(app)/claims/setup/+route'
import { Route as appEapReviewsChar43routeRouteImport } from './pages/(app)/eap/reviews/+route'
import { Route as appEapChar43indexRouteImport } from './pages/(app)/eap/+index'
import { Route as appMarketplaceChar43indexRouteImport } from './pages/(app)/marketplace/+index'
import { Route as appMessagesChar43indexRouteImport } from './pages/(app)/messages/+index'
import { Route as appMessagesConversationIdChar43routeRouteImport } from './pages/(app)/messages/$conversationId/+route'
import { Route as appPurchasesChar43indexRouteImport } from './pages/(app)/purchases/+index'
import { Route as appResourcesChar43indexRouteImport } from './pages/(app)/resources/+index'
import { Route as appResourcesResourceIdChar43routeRouteImport } from './pages/(app)/resources/$resourceId/+route'
import { Route as appSettingsChar43indexDotlazyRouteImport } from './pages/(app)/settings/+index.lazy'
import { Route as appTopUpChar43indexRouteImport } from './pages/(app)/top-up/+index'
import { Route as appTopUpCompleteChar43routeRouteImport } from './pages/(app)/top-up/complete/+route'
import { Route as appWalletChar43indexRouteImport } from './pages/(app)/wallet/+index'
import { Route as appWalletExpiringChar43routeRouteImport } from './pages/(app)/wallet/expiring/+route'
import { Route as appClaimsHelpChar43indexRouteImport } from './pages/(app)/claims/help/+index'
import { Route as appClaimsHelpAllowanceChar43routeRouteImport } from './pages/(app)/claims/help/allowance/+route'
import { Route as appClaimsHelpEapChar43routeRouteImport } from './pages/(app)/claims/help/eap/+route'
import { Route as appClaimsPolicyChar43indexRouteImport } from './pages/(app)/claims/policy/+index'
import { Route as appClaimsPolicyAllowanceChar43routeRouteImport } from './pages/(app)/claims/policy/allowance/+route'
import { Route as appClaimsPolicyEapChar43routeRouteImport } from './pages/(app)/claims/policy/eap/+route'
import { Route as appEapListingsListingIdChar43routeRouteImport } from './pages/(app)/eap/listings/$listingId/+route'
import { Route as appMarketplaceListingsListingIdChar43routeRouteImport } from './pages/(app)/marketplace/listings/$listingId/+route'
import { Route as appMarketplaceSuppliersSupplierIdChar43routeRouteImport } from './pages/(app)/marketplace/suppliers/$supplierId/+route'
import { Route as appPurchasesPurchaseIdCancelChar43routeRouteImport } from './pages/(app)/purchases/$purchaseId/cancel/+route'
import { Route as appTopUpCheckoutChar43routeRouteImport } from './pages/(app)/top-up/checkout/+route'
import { Route as appEapPurchaseChar43routeRouteImport } from './pages/(app)/eap/purchase/+route'
import { Route as appEapRequestChar43routeRouteImport } from './pages/(app)/eap/request/+route'
import { Route as appMarketplacePurchaseChar43routeRouteImport } from './pages/(app)/marketplace/purchase/+route'
import { Route as appMarketplaceRequestChar43routeRouteImport } from './pages/(app)/marketplace/request/+route'
import { Route as appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRouteImport } from './pages/(app)/purchases/subscriptions/$subscriptionId/cancel/+route'

const Char43indexRoute = Char43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Char43authRoute = Char43authRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const demoChar43routeRoute = demoChar43routeRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const forgotPasswordChar43routeRoute =
  forgotPasswordChar43routeRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const newAccountChar43routeRoute = newAccountChar43routeRouteImport.update({
  id: '/new-account',
  path: '/new-account',
  getParentRoute: () => rootRouteImport,
} as any)
const nominateChar43routeRoute = nominateChar43routeRouteImport.update({
  id: '/nominate',
  path: '/nominate',
  getParentRoute: () => rootRouteImport,
} as any)
const signInChar43routeRoute = signInChar43routeRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const appChar43routeRoute = appChar43routeRouteImport.update({
  id: '/_app',
  getParentRoute: () => Char43authRoute,
} as any)
const mergeAccountChar43routeRoute = mergeAccountChar43routeRouteImport.update({
  id: '/merge-account',
  path: '/merge-account',
  getParentRoute: () => Char43authRoute,
} as any)
const giftActivateChar43routeRoute = giftActivateChar43routeRouteImport.update({
  id: '/gift/activate',
  path: '/gift/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const invitationActivateChar43routeRoute =
  invitationActivateChar43routeRouteImport.update({
    id: '/invitation/activate',
    path: '/invitation/activate',
    getParentRoute: () => rootRouteImport,
  } as any)
const policiesTermsChar43routeRoute =
  policiesTermsChar43routeRouteImport.update({
    id: '/policies/terms',
    path: '/policies/terms',
    getParentRoute: () => rootRouteImport,
  } as any)
const appClaimsChar43routeRoute = appClaimsChar43routeRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appEapChar43routeRoute = appEapChar43routeRouteImport.update({
  id: '/eap',
  path: '/eap',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appFavouritesIndexRoute = appFavouritesIndexRouteImport.update({
  id: '/favourites',
  path: '/favourites',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appHomeIndexRoute = appHomeIndexRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appMessagesChar43routeRoute = appMessagesChar43routeRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appPurchasesChar43routeRoute = appPurchasesChar43routeRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appResourcesChar43routeRoute = appResourcesChar43routeRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appSettingsChar43routeRoute = appSettingsChar43routeRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appTopUpChar43routeRoute = appTopUpChar43routeRouteImport.update({
  id: '/top-up',
  path: '/top-up',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appWalletChar43routeRoute = appWalletChar43routeRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => appChar43routeRoute,
} as any)
const appClaimsChar43indexRoute = appClaimsChar43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appClaimsChar43routeRoute,
} as any)
const appClaimsChar91claimIdChar93Char43routeRoute =
  appClaimsChar91claimIdChar93Char43routeRouteImport.update({
    id: '/$claimId',
    path: '/$claimId',
    getParentRoute: () => appClaimsChar43routeRoute,
  } as any)
const appClaimsHelpChar43routeRoute =
  appClaimsHelpChar43routeRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => appClaimsChar43routeRoute,
  } as any)
const appClaimsNewChar43routeRoute = appClaimsNewChar43routeRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => appClaimsChar43routeRoute,
} as any)
const appClaimsPolicyChar43routeRoute =
  appClaimsPolicyChar43routeRouteImport.update({
    id: '/policy',
    path: '/policy',
    getParentRoute: () => appClaimsChar43routeRoute,
  } as any)
const appClaimsSetupChar43routeRoute =
  appClaimsSetupChar43routeRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => appClaimsChar43routeRoute,
  } as any)
const appEapReviewsChar43routeRoute =
  appEapReviewsChar43routeRouteImport.update({
    id: '/eap-review/$purchaseId',
    path: '/eap-review/$purchaseId',
    getParentRoute: () => appChar43routeRoute,
  } as any)
const appEapChar43indexRoute = appEapChar43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appEapChar43routeRoute,
} as any)
const appMarketplaceChar43indexRoute =
  appMarketplaceChar43indexRouteImport.update({
    id: '/marketplace/',
    path: '/marketplace/',
    getParentRoute: () => appChar43routeRoute,
  } as any)
const appMessagesChar43indexRoute = appMessagesChar43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appMessagesChar43routeRoute,
} as any)
const appMessagesConversationIdChar43routeRoute =
  appMessagesConversationIdChar43routeRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => appMessagesChar43routeRoute,
  } as any)
const appPurchasesChar43indexRoute = appPurchasesChar43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appPurchasesChar43routeRoute,
} as any)
const appResourcesChar43indexRoute = appResourcesChar43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appResourcesChar43routeRoute,
} as any)
const appResourcesResourceIdChar43routeRoute =
  appResourcesResourceIdChar43routeRouteImport.update({
    id: '/$resourceId',
    path: '/$resourceId',
    getParentRoute: () => appResourcesChar43routeRoute,
  } as any)
const appSettingsChar43indexDotlazyRoute =
  appSettingsChar43indexDotlazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appSettingsChar43routeRoute,
  } as any)
const appTopUpChar43indexRoute = appTopUpChar43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appTopUpChar43routeRoute,
} as any)
const appTopUpCompleteChar43routeRoute =
  appTopUpCompleteChar43routeRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => appTopUpChar43routeRoute,
  } as any)
const appWalletChar43indexRoute = appWalletChar43indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appWalletChar43routeRoute,
} as any)
const appWalletExpiringChar43routeRoute =
  appWalletExpiringChar43routeRouteImport.update({
    id: '/expiring',
    path: '/expiring',
    getParentRoute: () => appWalletChar43routeRoute,
  } as any)
const appClaimsHelpChar43indexRoute =
  appClaimsHelpChar43indexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appClaimsHelpChar43routeRoute,
  } as any)
const appClaimsHelpAllowanceChar43routeRoute =
  appClaimsHelpAllowanceChar43routeRouteImport.update({
    id: '/allowance',
    path: '/allowance',
    getParentRoute: () => appClaimsHelpChar43routeRoute,
  } as any)
const appClaimsHelpEapChar43routeRoute =
  appClaimsHelpEapChar43routeRouteImport.update({
    id: '/eap',
    path: '/eap',
    getParentRoute: () => appClaimsHelpChar43routeRoute,
  } as any)
const appClaimsPolicyChar43indexRoute =
  appClaimsPolicyChar43indexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appClaimsPolicyChar43routeRoute,
  } as any)
const appClaimsPolicyAllowanceChar43routeRoute =
  appClaimsPolicyAllowanceChar43routeRouteImport.update({
    id: '/allowance',
    path: '/allowance',
    getParentRoute: () => appClaimsPolicyChar43routeRoute,
  } as any)
const appClaimsPolicyEapChar43routeRoute =
  appClaimsPolicyEapChar43routeRouteImport.update({
    id: '/eap',
    path: '/eap',
    getParentRoute: () => appClaimsPolicyChar43routeRoute,
  } as any)
const appEapListingsListingIdChar43routeRoute =
  appEapListingsListingIdChar43routeRouteImport.update({
    id: '/listings/$listingId',
    path: '/listings/$listingId',
    getParentRoute: () => appEapChar43routeRoute,
  } as any)
const appMarketplaceListingsListingIdChar43routeRoute =
  appMarketplaceListingsListingIdChar43routeRouteImport.update({
    id: '/marketplace/listings/$listingId',
    path: '/marketplace/listings/$listingId',
    getParentRoute: () => appChar43routeRoute,
  } as any)
const appMarketplaceSuppliersSupplierIdChar43routeRoute =
  appMarketplaceSuppliersSupplierIdChar43routeRouteImport.update({
    id: '/marketplace/suppliers/$supplierId',
    path: '/marketplace/suppliers/$supplierId',
    getParentRoute: () => appChar43routeRoute,
  } as any)
const appPurchasesPurchaseIdCancelChar43routeRoute =
  appPurchasesPurchaseIdCancelChar43routeRouteImport.update({
    id: '/$purchaseId/cancel',
    path: '/$purchaseId/cancel',
    getParentRoute: () => appPurchasesChar43routeRoute,
  } as any)
const appTopUpCheckoutChar43routeRoute =
  appTopUpCheckoutChar43routeRouteImport.update({
    id: '/checkout/$tokenAmount',
    path: '/checkout/$tokenAmount',
    getParentRoute: () => appTopUpChar43routeRoute,
  } as any)
const appEapPurchaseChar43routeRoute =
  appEapPurchaseChar43routeRouteImport.update({
    id: '/purchase/$listingId/$variantId',
    path: '/purchase/$listingId/$variantId',
    getParentRoute: () => appEapChar43routeRoute,
  } as any)
const appEapRequestChar43routeRoute =
  appEapRequestChar43routeRouteImport.update({
    id: '/request/$listingId/$variantId',
    path: '/request/$listingId/$variantId',
    getParentRoute: () => appEapChar43routeRoute,
  } as any)
const appMarketplacePurchaseChar43routeRoute =
  appMarketplacePurchaseChar43routeRouteImport.update({
    id: '/marketplace/purchase/$listingId/$variantId',
    path: '/marketplace/purchase/$listingId/$variantId',
    getParentRoute: () => appChar43routeRoute,
  } as any)
const appMarketplaceRequestChar43routeRoute =
  appMarketplaceRequestChar43routeRouteImport.update({
    id: '/marketplace/request/$listingId/$variantId',
    path: '/marketplace/request/$listingId/$variantId',
    getParentRoute: () => appChar43routeRoute,
  } as any)
const appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute =
  appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRouteImport.update({
    id: '/subscriptions/$subscriptionId/cancel',
    path: '/subscriptions/$subscriptionId/cancel',
    getParentRoute: () => appPurchasesChar43routeRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof Char43indexRoute
  '/demo': typeof demoChar43routeRoute
  '/forgot-password': typeof forgotPasswordChar43routeRoute
  '/new-account': typeof newAccountChar43routeRoute
  '/nominate': typeof nominateChar43routeRoute
  '/sign-in': typeof signInChar43routeRoute
  '/merge-account': typeof mergeAccountChar43routeRoute
  '/gift/activate': typeof giftActivateChar43routeRoute
  '/invitation/activate': typeof invitationActivateChar43routeRoute
  '/policies/terms': typeof policiesTermsChar43routeRoute
  '/claims': typeof appClaimsChar43routeRouteWithChildren
  '/eap': typeof appEapChar43routeRouteWithChildren
  '/messages': typeof appMessagesChar43routeRouteWithChildren
  '/purchases': typeof appPurchasesChar43routeRouteWithChildren
  '/resources': typeof appResourcesChar43routeRouteWithChildren
  '/settings': typeof appSettingsChar43routeRouteWithChildren
  '/top-up': typeof appTopUpChar43routeRouteWithChildren
  '/wallet': typeof appWalletChar43routeRouteWithChildren
  '/favourites': typeof appFavouritesIndexRoute
  '/home': typeof appHomeIndexRoute
  '/claims/': typeof appClaimsChar43indexRoute
  '/eap/': typeof appEapChar43indexRoute
  '/marketplace/': typeof appMarketplaceChar43indexRoute
  '/messages/': typeof appMessagesChar43indexRoute
  '/purchases/': typeof appPurchasesChar43indexRoute
  '/resources/': typeof appResourcesChar43indexRoute
  '/top-up/': typeof appTopUpChar43indexRoute
  '/wallet/': typeof appWalletChar43indexRoute
  '/claims/$claimId': typeof appClaimsChar91claimIdChar93Char43routeRoute
  '/claims/help': typeof appClaimsHelpChar43routeRouteWithChildren
  '/claims/new': typeof appClaimsNewChar43routeRoute
  '/claims/policy': typeof appClaimsPolicyChar43routeRouteWithChildren
  '/claims/setup': typeof appClaimsSetupChar43routeRoute
  '/eap-review/$purchaseId': typeof appEapReviewsChar43routeRoute
  '/messages/$conversationId': typeof appMessagesConversationIdChar43routeRoute
  '/resources/$resourceId': typeof appResourcesResourceIdChar43routeRoute
  '/top-up/complete': typeof appTopUpCompleteChar43routeRoute
  '/wallet/expiring': typeof appWalletExpiringChar43routeRoute
  '/settings/': typeof appSettingsChar43indexDotlazyRoute
  '/claims/help/': typeof appClaimsHelpChar43indexRoute
  '/claims/policy/': typeof appClaimsPolicyChar43indexRoute
  '/claims/help/allowance': typeof appClaimsHelpAllowanceChar43routeRoute
  '/claims/help/eap': typeof appClaimsHelpEapChar43routeRoute
  '/claims/policy/allowance': typeof appClaimsPolicyAllowanceChar43routeRoute
  '/claims/policy/eap': typeof appClaimsPolicyEapChar43routeRoute
  '/eap/listings/$listingId': typeof appEapListingsListingIdChar43routeRoute
  '/marketplace/listings/$listingId': typeof appMarketplaceListingsListingIdChar43routeRoute
  '/marketplace/suppliers/$supplierId': typeof appMarketplaceSuppliersSupplierIdChar43routeRoute
  '/purchases/$purchaseId/cancel': typeof appPurchasesPurchaseIdCancelChar43routeRoute
  '/top-up/checkout/$tokenAmount': typeof appTopUpCheckoutChar43routeRoute
  '/eap/purchase/$listingId/$variantId': typeof appEapPurchaseChar43routeRoute
  '/eap/request/$listingId/$variantId': typeof appEapRequestChar43routeRoute
  '/marketplace/purchase/$listingId/$variantId': typeof appMarketplacePurchaseChar43routeRoute
  '/marketplace/request/$listingId/$variantId': typeof appMarketplaceRequestChar43routeRoute
  '/purchases/subscriptions/$subscriptionId/cancel': typeof appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute
}
export interface FileRoutesByTo {
  '/': typeof Char43indexRoute
  '/demo': typeof demoChar43routeRoute
  '/forgot-password': typeof forgotPasswordChar43routeRoute
  '/new-account': typeof newAccountChar43routeRoute
  '/nominate': typeof nominateChar43routeRoute
  '/sign-in': typeof signInChar43routeRoute
  '/merge-account': typeof mergeAccountChar43routeRoute
  '/gift/activate': typeof giftActivateChar43routeRoute
  '/invitation/activate': typeof invitationActivateChar43routeRoute
  '/policies/terms': typeof policiesTermsChar43routeRoute
  '/favourites': typeof appFavouritesIndexRoute
  '/home': typeof appHomeIndexRoute
  '/claims': typeof appClaimsChar43indexRoute
  '/eap': typeof appEapChar43indexRoute
  '/marketplace': typeof appMarketplaceChar43indexRoute
  '/messages': typeof appMessagesChar43indexRoute
  '/purchases': typeof appPurchasesChar43indexRoute
  '/resources': typeof appResourcesChar43indexRoute
  '/top-up': typeof appTopUpChar43indexRoute
  '/wallet': typeof appWalletChar43indexRoute
  '/claims/$claimId': typeof appClaimsChar91claimIdChar93Char43routeRoute
  '/claims/new': typeof appClaimsNewChar43routeRoute
  '/claims/setup': typeof appClaimsSetupChar43routeRoute
  '/eap-review/$purchaseId': typeof appEapReviewsChar43routeRoute
  '/messages/$conversationId': typeof appMessagesConversationIdChar43routeRoute
  '/resources/$resourceId': typeof appResourcesResourceIdChar43routeRoute
  '/top-up/complete': typeof appTopUpCompleteChar43routeRoute
  '/wallet/expiring': typeof appWalletExpiringChar43routeRoute
  '/settings': typeof appSettingsChar43indexDotlazyRoute
  '/claims/help': typeof appClaimsHelpChar43indexRoute
  '/claims/policy': typeof appClaimsPolicyChar43indexRoute
  '/claims/help/allowance': typeof appClaimsHelpAllowanceChar43routeRoute
  '/claims/help/eap': typeof appClaimsHelpEapChar43routeRoute
  '/claims/policy/allowance': typeof appClaimsPolicyAllowanceChar43routeRoute
  '/claims/policy/eap': typeof appClaimsPolicyEapChar43routeRoute
  '/eap/listings/$listingId': typeof appEapListingsListingIdChar43routeRoute
  '/marketplace/listings/$listingId': typeof appMarketplaceListingsListingIdChar43routeRoute
  '/marketplace/suppliers/$supplierId': typeof appMarketplaceSuppliersSupplierIdChar43routeRoute
  '/purchases/$purchaseId/cancel': typeof appPurchasesPurchaseIdCancelChar43routeRoute
  '/top-up/checkout/$tokenAmount': typeof appTopUpCheckoutChar43routeRoute
  '/eap/purchase/$listingId/$variantId': typeof appEapPurchaseChar43routeRoute
  '/eap/request/$listingId/$variantId': typeof appEapRequestChar43routeRoute
  '/marketplace/purchase/$listingId/$variantId': typeof appMarketplacePurchaseChar43routeRoute
  '/marketplace/request/$listingId/$variantId': typeof appMarketplaceRequestChar43routeRoute
  '/purchases/subscriptions/$subscriptionId/cancel': typeof appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof Char43indexRoute
  '/_auth': typeof Char43authRouteWithChildren
  '/demo': typeof demoChar43routeRoute
  '/forgot-password': typeof forgotPasswordChar43routeRoute
  '/new-account': typeof newAccountChar43routeRoute
  '/nominate': typeof nominateChar43routeRoute
  '/sign-in': typeof signInChar43routeRoute
  '/_auth/_app': typeof appChar43routeRouteWithChildren
  '/_auth/merge-account': typeof mergeAccountChar43routeRoute
  '/gift/activate': typeof giftActivateChar43routeRoute
  '/invitation/activate': typeof invitationActivateChar43routeRoute
  '/policies/terms': typeof policiesTermsChar43routeRoute
  '/_auth/_app/claims': typeof appClaimsChar43routeRouteWithChildren
  '/_auth/_app/eap': typeof appEapChar43routeRouteWithChildren
  '/_auth/_app/messages': typeof appMessagesChar43routeRouteWithChildren
  '/_auth/_app/purchases': typeof appPurchasesChar43routeRouteWithChildren
  '/_auth/_app/resources': typeof appResourcesChar43routeRouteWithChildren
  '/_auth/_app/settings': typeof appSettingsChar43routeRouteWithChildren
  '/_auth/_app/top-up': typeof appTopUpChar43routeRouteWithChildren
  '/_auth/_app/wallet': typeof appWalletChar43routeRouteWithChildren
  '/_auth/_app/favourites': typeof appFavouritesIndexRoute
  '/_auth/_app/home': typeof appHomeIndexRoute
  '/_auth/_app/claims/': typeof appClaimsChar43indexRoute
  '/_auth/_app/eap/': typeof appEapChar43indexRoute
  '/_auth/_app/marketplace/': typeof appMarketplaceChar43indexRoute
  '/_auth/_app/messages/': typeof appMessagesChar43indexRoute
  '/_auth/_app/purchases/': typeof appPurchasesChar43indexRoute
  '/_auth/_app/resources/': typeof appResourcesChar43indexRoute
  '/_auth/_app/top-up/': typeof appTopUpChar43indexRoute
  '/_auth/_app/wallet/': typeof appWalletChar43indexRoute
  '/_auth/_app/claims/$claimId': typeof appClaimsChar91claimIdChar93Char43routeRoute
  '/_auth/_app/claims/help': typeof appClaimsHelpChar43routeRouteWithChildren
  '/_auth/_app/claims/new': typeof appClaimsNewChar43routeRoute
  '/_auth/_app/claims/policy': typeof appClaimsPolicyChar43routeRouteWithChildren
  '/_auth/_app/claims/setup': typeof appClaimsSetupChar43routeRoute
  '/_auth/_app/eap-review/$purchaseId': typeof appEapReviewsChar43routeRoute
  '/_auth/_app/messages/$conversationId': typeof appMessagesConversationIdChar43routeRoute
  '/_auth/_app/resources/$resourceId': typeof appResourcesResourceIdChar43routeRoute
  '/_auth/_app/top-up/complete': typeof appTopUpCompleteChar43routeRoute
  '/_auth/_app/wallet/expiring': typeof appWalletExpiringChar43routeRoute
  '/_auth/_app/settings/': typeof appSettingsChar43indexDotlazyRoute
  '/_auth/_app/claims/help/': typeof appClaimsHelpChar43indexRoute
  '/_auth/_app/claims/policy/': typeof appClaimsPolicyChar43indexRoute
  '/_auth/_app/claims/help/allowance': typeof appClaimsHelpAllowanceChar43routeRoute
  '/_auth/_app/claims/help/eap': typeof appClaimsHelpEapChar43routeRoute
  '/_auth/_app/claims/policy/allowance': typeof appClaimsPolicyAllowanceChar43routeRoute
  '/_auth/_app/claims/policy/eap': typeof appClaimsPolicyEapChar43routeRoute
  '/_auth/_app/eap/listings/$listingId': typeof appEapListingsListingIdChar43routeRoute
  '/_auth/_app/marketplace/listings/$listingId': typeof appMarketplaceListingsListingIdChar43routeRoute
  '/_auth/_app/marketplace/suppliers/$supplierId': typeof appMarketplaceSuppliersSupplierIdChar43routeRoute
  '/_auth/_app/purchases/$purchaseId/cancel': typeof appPurchasesPurchaseIdCancelChar43routeRoute
  '/_auth/_app/top-up/checkout/$tokenAmount': typeof appTopUpCheckoutChar43routeRoute
  '/_auth/_app/eap/purchase/$listingId/$variantId': typeof appEapPurchaseChar43routeRoute
  '/_auth/_app/eap/request/$listingId/$variantId': typeof appEapRequestChar43routeRoute
  '/_auth/_app/marketplace/purchase/$listingId/$variantId': typeof appMarketplacePurchaseChar43routeRoute
  '/_auth/_app/marketplace/request/$listingId/$variantId': typeof appMarketplaceRequestChar43routeRoute
  '/_auth/_app/purchases/subscriptions/$subscriptionId/cancel': typeof appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/demo'
    | '/forgot-password'
    | '/new-account'
    | '/nominate'
    | '/sign-in'
    | '/merge-account'
    | '/gift/activate'
    | '/invitation/activate'
    | '/policies/terms'
    | '/claims'
    | '/eap'
    | '/messages'
    | '/purchases'
    | '/resources'
    | '/settings'
    | '/top-up'
    | '/wallet'
    | '/favourites'
    | '/home'
    | '/claims/'
    | '/eap/'
    | '/marketplace/'
    | '/messages/'
    | '/purchases/'
    | '/resources/'
    | '/top-up/'
    | '/wallet/'
    | '/claims/$claimId'
    | '/claims/help'
    | '/claims/new'
    | '/claims/policy'
    | '/claims/setup'
    | '/eap-review/$purchaseId'
    | '/messages/$conversationId'
    | '/resources/$resourceId'
    | '/top-up/complete'
    | '/wallet/expiring'
    | '/settings/'
    | '/claims/help/'
    | '/claims/policy/'
    | '/claims/help/allowance'
    | '/claims/help/eap'
    | '/claims/policy/allowance'
    | '/claims/policy/eap'
    | '/eap/listings/$listingId'
    | '/marketplace/listings/$listingId'
    | '/marketplace/suppliers/$supplierId'
    | '/purchases/$purchaseId/cancel'
    | '/top-up/checkout/$tokenAmount'
    | '/eap/purchase/$listingId/$variantId'
    | '/eap/request/$listingId/$variantId'
    | '/marketplace/purchase/$listingId/$variantId'
    | '/marketplace/request/$listingId/$variantId'
    | '/purchases/subscriptions/$subscriptionId/cancel'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/demo'
    | '/forgot-password'
    | '/new-account'
    | '/nominate'
    | '/sign-in'
    | '/merge-account'
    | '/gift/activate'
    | '/invitation/activate'
    | '/policies/terms'
    | '/favourites'
    | '/home'
    | '/claims'
    | '/eap'
    | '/marketplace'
    | '/messages'
    | '/purchases'
    | '/resources'
    | '/top-up'
    | '/wallet'
    | '/claims/$claimId'
    | '/claims/new'
    | '/claims/setup'
    | '/eap-review/$purchaseId'
    | '/messages/$conversationId'
    | '/resources/$resourceId'
    | '/top-up/complete'
    | '/wallet/expiring'
    | '/settings'
    | '/claims/help'
    | '/claims/policy'
    | '/claims/help/allowance'
    | '/claims/help/eap'
    | '/claims/policy/allowance'
    | '/claims/policy/eap'
    | '/eap/listings/$listingId'
    | '/marketplace/listings/$listingId'
    | '/marketplace/suppliers/$supplierId'
    | '/purchases/$purchaseId/cancel'
    | '/top-up/checkout/$tokenAmount'
    | '/eap/purchase/$listingId/$variantId'
    | '/eap/request/$listingId/$variantId'
    | '/marketplace/purchase/$listingId/$variantId'
    | '/marketplace/request/$listingId/$variantId'
    | '/purchases/subscriptions/$subscriptionId/cancel'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/demo'
    | '/forgot-password'
    | '/new-account'
    | '/nominate'
    | '/sign-in'
    | '/_auth/_app'
    | '/_auth/merge-account'
    | '/gift/activate'
    | '/invitation/activate'
    | '/policies/terms'
    | '/_auth/_app/claims'
    | '/_auth/_app/eap'
    | '/_auth/_app/messages'
    | '/_auth/_app/purchases'
    | '/_auth/_app/resources'
    | '/_auth/_app/settings'
    | '/_auth/_app/top-up'
    | '/_auth/_app/wallet'
    | '/_auth/_app/favourites'
    | '/_auth/_app/home'
    | '/_auth/_app/claims/'
    | '/_auth/_app/eap/'
    | '/_auth/_app/marketplace/'
    | '/_auth/_app/messages/'
    | '/_auth/_app/purchases/'
    | '/_auth/_app/resources/'
    | '/_auth/_app/top-up/'
    | '/_auth/_app/wallet/'
    | '/_auth/_app/claims/$claimId'
    | '/_auth/_app/claims/help'
    | '/_auth/_app/claims/new'
    | '/_auth/_app/claims/policy'
    | '/_auth/_app/claims/setup'
    | '/_auth/_app/eap-review/$purchaseId'
    | '/_auth/_app/messages/$conversationId'
    | '/_auth/_app/resources/$resourceId'
    | '/_auth/_app/top-up/complete'
    | '/_auth/_app/wallet/expiring'
    | '/_auth/_app/settings/'
    | '/_auth/_app/claims/help/'
    | '/_auth/_app/claims/policy/'
    | '/_auth/_app/claims/help/allowance'
    | '/_auth/_app/claims/help/eap'
    | '/_auth/_app/claims/policy/allowance'
    | '/_auth/_app/claims/policy/eap'
    | '/_auth/_app/eap/listings/$listingId'
    | '/_auth/_app/marketplace/listings/$listingId'
    | '/_auth/_app/marketplace/suppliers/$supplierId'
    | '/_auth/_app/purchases/$purchaseId/cancel'
    | '/_auth/_app/top-up/checkout/$tokenAmount'
    | '/_auth/_app/eap/purchase/$listingId/$variantId'
    | '/_auth/_app/eap/request/$listingId/$variantId'
    | '/_auth/_app/marketplace/purchase/$listingId/$variantId'
    | '/_auth/_app/marketplace/request/$listingId/$variantId'
    | '/_auth/_app/purchases/subscriptions/$subscriptionId/cancel'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Char43indexRoute: typeof Char43indexRoute
  Char43authRoute: typeof Char43authRouteWithChildren
  demoChar43routeRoute: typeof demoChar43routeRoute
  forgotPasswordChar43routeRoute: typeof forgotPasswordChar43routeRoute
  newAccountChar43routeRoute: typeof newAccountChar43routeRoute
  nominateChar43routeRoute: typeof nominateChar43routeRoute
  signInChar43routeRoute: typeof signInChar43routeRoute
  giftActivateChar43routeRoute: typeof giftActivateChar43routeRoute
  invitationActivateChar43routeRoute: typeof invitationActivateChar43routeRoute
  policiesTermsChar43routeRoute: typeof policiesTermsChar43routeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof Char43indexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof Char43authRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof demoChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof forgotPasswordChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-account': {
      id: '/new-account'
      path: '/new-account'
      fullPath: '/new-account'
      preLoaderRoute: typeof newAccountChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nominate': {
      id: '/nominate'
      path: '/nominate'
      fullPath: '/nominate'
      preLoaderRoute: typeof nominateChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof signInChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_app': {
      id: '/_auth/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof appChar43routeRouteImport
      parentRoute: typeof Char43authRoute
    }
    '/_auth/merge-account': {
      id: '/_auth/merge-account'
      path: '/merge-account'
      fullPath: '/merge-account'
      preLoaderRoute: typeof mergeAccountChar43routeRouteImport
      parentRoute: typeof Char43authRoute
    }
    '/gift/activate': {
      id: '/gift/activate'
      path: '/gift/activate'
      fullPath: '/gift/activate'
      preLoaderRoute: typeof giftActivateChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation/activate': {
      id: '/invitation/activate'
      path: '/invitation/activate'
      fullPath: '/invitation/activate'
      preLoaderRoute: typeof invitationActivateChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/terms': {
      id: '/policies/terms'
      path: '/policies/terms'
      fullPath: '/policies/terms'
      preLoaderRoute: typeof policiesTermsChar43routeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_app/claims': {
      id: '/_auth/_app/claims'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof appClaimsChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/eap': {
      id: '/_auth/_app/eap'
      path: '/eap'
      fullPath: '/eap'
      preLoaderRoute: typeof appEapChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/favourites': {
      id: '/_auth/_app/favourites'
      path: '/favourites'
      fullPath: '/favourites'
      preLoaderRoute: typeof appFavouritesIndexRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/home': {
      id: '/_auth/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof appHomeIndexRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/messages': {
      id: '/_auth/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof appMessagesChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/purchases': {
      id: '/_auth/_app/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof appPurchasesChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/resources': {
      id: '/_auth/_app/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof appResourcesChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/settings': {
      id: '/_auth/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appSettingsChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/top-up': {
      id: '/_auth/_app/top-up'
      path: '/top-up'
      fullPath: '/top-up'
      preLoaderRoute: typeof appTopUpChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/wallet': {
      id: '/_auth/_app/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof appWalletChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/claims/': {
      id: '/_auth/_app/claims/'
      path: '/'
      fullPath: '/claims/'
      preLoaderRoute: typeof appClaimsChar43indexRouteImport
      parentRoute: typeof appClaimsChar43routeRoute
    }
    '/_auth/_app/claims/$claimId': {
      id: '/_auth/_app/claims/$claimId'
      path: '/$claimId'
      fullPath: '/claims/$claimId'
      preLoaderRoute: typeof appClaimsChar91claimIdChar93Char43routeRouteImport
      parentRoute: typeof appClaimsChar43routeRoute
    }
    '/_auth/_app/claims/help': {
      id: '/_auth/_app/claims/help'
      path: '/help'
      fullPath: '/claims/help'
      preLoaderRoute: typeof appClaimsHelpChar43routeRouteImport
      parentRoute: typeof appClaimsChar43routeRoute
    }
    '/_auth/_app/claims/new': {
      id: '/_auth/_app/claims/new'
      path: '/new'
      fullPath: '/claims/new'
      preLoaderRoute: typeof appClaimsNewChar43routeRouteImport
      parentRoute: typeof appClaimsChar43routeRoute
    }
    '/_auth/_app/claims/policy': {
      id: '/_auth/_app/claims/policy'
      path: '/policy'
      fullPath: '/claims/policy'
      preLoaderRoute: typeof appClaimsPolicyChar43routeRouteImport
      parentRoute: typeof appClaimsChar43routeRoute
    }
    '/_auth/_app/claims/setup': {
      id: '/_auth/_app/claims/setup'
      path: '/setup'
      fullPath: '/claims/setup'
      preLoaderRoute: typeof appClaimsSetupChar43routeRouteImport
      parentRoute: typeof appClaimsChar43routeRoute
    }
    '/_auth/_app/eap-review/$purchaseId': {
      id: '/_auth/_app/eap-review/$purchaseId'
      path: '/eap-review/$purchaseId'
      fullPath: '/eap-review/$purchaseId'
      preLoaderRoute: typeof appEapReviewsChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/eap/': {
      id: '/_auth/_app/eap/'
      path: '/'
      fullPath: '/eap/'
      preLoaderRoute: typeof appEapChar43indexRouteImport
      parentRoute: typeof appEapChar43routeRoute
    }
    '/_auth/_app/marketplace/': {
      id: '/_auth/_app/marketplace/'
      path: '/marketplace'
      fullPath: '/marketplace/'
      preLoaderRoute: typeof appMarketplaceChar43indexRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/messages/': {
      id: '/_auth/_app/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof appMessagesChar43indexRouteImport
      parentRoute: typeof appMessagesChar43routeRoute
    }
    '/_auth/_app/messages/$conversationId': {
      id: '/_auth/_app/messages/$conversationId'
      path: '/$conversationId'
      fullPath: '/messages/$conversationId'
      preLoaderRoute: typeof appMessagesConversationIdChar43routeRouteImport
      parentRoute: typeof appMessagesChar43routeRoute
    }
    '/_auth/_app/purchases/': {
      id: '/_auth/_app/purchases/'
      path: '/'
      fullPath: '/purchases/'
      preLoaderRoute: typeof appPurchasesChar43indexRouteImport
      parentRoute: typeof appPurchasesChar43routeRoute
    }
    '/_auth/_app/resources/': {
      id: '/_auth/_app/resources/'
      path: '/'
      fullPath: '/resources/'
      preLoaderRoute: typeof appResourcesChar43indexRouteImport
      parentRoute: typeof appResourcesChar43routeRoute
    }
    '/_auth/_app/resources/$resourceId': {
      id: '/_auth/_app/resources/$resourceId'
      path: '/$resourceId'
      fullPath: '/resources/$resourceId'
      preLoaderRoute: typeof appResourcesResourceIdChar43routeRouteImport
      parentRoute: typeof appResourcesChar43routeRoute
    }
    '/_auth/_app/settings/': {
      id: '/_auth/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof appSettingsChar43indexDotlazyRouteImport
      parentRoute: typeof appSettingsChar43routeRoute
    }
    '/_auth/_app/top-up/': {
      id: '/_auth/_app/top-up/'
      path: '/'
      fullPath: '/top-up/'
      preLoaderRoute: typeof appTopUpChar43indexRouteImport
      parentRoute: typeof appTopUpChar43routeRoute
    }
    '/_auth/_app/top-up/complete': {
      id: '/_auth/_app/top-up/complete'
      path: '/complete'
      fullPath: '/top-up/complete'
      preLoaderRoute: typeof appTopUpCompleteChar43routeRouteImport
      parentRoute: typeof appTopUpChar43routeRoute
    }
    '/_auth/_app/wallet/': {
      id: '/_auth/_app/wallet/'
      path: '/'
      fullPath: '/wallet/'
      preLoaderRoute: typeof appWalletChar43indexRouteImport
      parentRoute: typeof appWalletChar43routeRoute
    }
    '/_auth/_app/wallet/expiring': {
      id: '/_auth/_app/wallet/expiring'
      path: '/expiring'
      fullPath: '/wallet/expiring'
      preLoaderRoute: typeof appWalletExpiringChar43routeRouteImport
      parentRoute: typeof appWalletChar43routeRoute
    }
    '/_auth/_app/claims/help/': {
      id: '/_auth/_app/claims/help/'
      path: '/'
      fullPath: '/claims/help/'
      preLoaderRoute: typeof appClaimsHelpChar43indexRouteImport
      parentRoute: typeof appClaimsHelpChar43routeRoute
    }
    '/_auth/_app/claims/help/allowance': {
      id: '/_auth/_app/claims/help/allowance'
      path: '/allowance'
      fullPath: '/claims/help/allowance'
      preLoaderRoute: typeof appClaimsHelpAllowanceChar43routeRouteImport
      parentRoute: typeof appClaimsHelpChar43routeRoute
    }
    '/_auth/_app/claims/help/eap': {
      id: '/_auth/_app/claims/help/eap'
      path: '/eap'
      fullPath: '/claims/help/eap'
      preLoaderRoute: typeof appClaimsHelpEapChar43routeRouteImport
      parentRoute: typeof appClaimsHelpChar43routeRoute
    }
    '/_auth/_app/claims/policy/': {
      id: '/_auth/_app/claims/policy/'
      path: '/'
      fullPath: '/claims/policy/'
      preLoaderRoute: typeof appClaimsPolicyChar43indexRouteImport
      parentRoute: typeof appClaimsPolicyChar43routeRoute
    }
    '/_auth/_app/claims/policy/allowance': {
      id: '/_auth/_app/claims/policy/allowance'
      path: '/allowance'
      fullPath: '/claims/policy/allowance'
      preLoaderRoute: typeof appClaimsPolicyAllowanceChar43routeRouteImport
      parentRoute: typeof appClaimsPolicyChar43routeRoute
    }
    '/_auth/_app/claims/policy/eap': {
      id: '/_auth/_app/claims/policy/eap'
      path: '/eap'
      fullPath: '/claims/policy/eap'
      preLoaderRoute: typeof appClaimsPolicyEapChar43routeRouteImport
      parentRoute: typeof appClaimsPolicyChar43routeRoute
    }
    '/_auth/_app/eap/listings/$listingId': {
      id: '/_auth/_app/eap/listings/$listingId'
      path: '/listings/$listingId'
      fullPath: '/eap/listings/$listingId'
      preLoaderRoute: typeof appEapListingsListingIdChar43routeRouteImport
      parentRoute: typeof appEapChar43routeRoute
    }
    '/_auth/_app/marketplace/listings/$listingId': {
      id: '/_auth/_app/marketplace/listings/$listingId'
      path: '/marketplace/listings/$listingId'
      fullPath: '/marketplace/listings/$listingId'
      preLoaderRoute: typeof appMarketplaceListingsListingIdChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/marketplace/suppliers/$supplierId': {
      id: '/_auth/_app/marketplace/suppliers/$supplierId'
      path: '/marketplace/suppliers/$supplierId'
      fullPath: '/marketplace/suppliers/$supplierId'
      preLoaderRoute: typeof appMarketplaceSuppliersSupplierIdChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/purchases/$purchaseId/cancel': {
      id: '/_auth/_app/purchases/$purchaseId/cancel'
      path: '/$purchaseId/cancel'
      fullPath: '/purchases/$purchaseId/cancel'
      preLoaderRoute: typeof appPurchasesPurchaseIdCancelChar43routeRouteImport
      parentRoute: typeof appPurchasesChar43routeRoute
    }
    '/_auth/_app/top-up/checkout/$tokenAmount': {
      id: '/_auth/_app/top-up/checkout/$tokenAmount'
      path: '/checkout/$tokenAmount'
      fullPath: '/top-up/checkout/$tokenAmount'
      preLoaderRoute: typeof appTopUpCheckoutChar43routeRouteImport
      parentRoute: typeof appTopUpChar43routeRoute
    }
    '/_auth/_app/eap/purchase/$listingId/$variantId': {
      id: '/_auth/_app/eap/purchase/$listingId/$variantId'
      path: '/purchase/$listingId/$variantId'
      fullPath: '/eap/purchase/$listingId/$variantId'
      preLoaderRoute: typeof appEapPurchaseChar43routeRouteImport
      parentRoute: typeof appEapChar43routeRoute
    }
    '/_auth/_app/eap/request/$listingId/$variantId': {
      id: '/_auth/_app/eap/request/$listingId/$variantId'
      path: '/request/$listingId/$variantId'
      fullPath: '/eap/request/$listingId/$variantId'
      preLoaderRoute: typeof appEapRequestChar43routeRouteImport
      parentRoute: typeof appEapChar43routeRoute
    }
    '/_auth/_app/marketplace/purchase/$listingId/$variantId': {
      id: '/_auth/_app/marketplace/purchase/$listingId/$variantId'
      path: '/marketplace/purchase/$listingId/$variantId'
      fullPath: '/marketplace/purchase/$listingId/$variantId'
      preLoaderRoute: typeof appMarketplacePurchaseChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/marketplace/request/$listingId/$variantId': {
      id: '/_auth/_app/marketplace/request/$listingId/$variantId'
      path: '/marketplace/request/$listingId/$variantId'
      fullPath: '/marketplace/request/$listingId/$variantId'
      preLoaderRoute: typeof appMarketplaceRequestChar43routeRouteImport
      parentRoute: typeof appChar43routeRoute
    }
    '/_auth/_app/purchases/subscriptions/$subscriptionId/cancel': {
      id: '/_auth/_app/purchases/subscriptions/$subscriptionId/cancel'
      path: '/subscriptions/$subscriptionId/cancel'
      fullPath: '/purchases/subscriptions/$subscriptionId/cancel'
      preLoaderRoute: typeof appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRouteImport
      parentRoute: typeof appPurchasesChar43routeRoute
    }
  }
}

interface appClaimsHelpChar43routeRouteChildren {
  appClaimsHelpChar43indexRoute: typeof appClaimsHelpChar43indexRoute
  appClaimsHelpAllowanceChar43routeRoute: typeof appClaimsHelpAllowanceChar43routeRoute
  appClaimsHelpEapChar43routeRoute: typeof appClaimsHelpEapChar43routeRoute
}

const appClaimsHelpChar43routeRouteChildren: appClaimsHelpChar43routeRouteChildren =
  {
    appClaimsHelpChar43indexRoute: appClaimsHelpChar43indexRoute,
    appClaimsHelpAllowanceChar43routeRoute:
      appClaimsHelpAllowanceChar43routeRoute,
    appClaimsHelpEapChar43routeRoute: appClaimsHelpEapChar43routeRoute,
  }

const appClaimsHelpChar43routeRouteWithChildren =
  appClaimsHelpChar43routeRoute._addFileChildren(
    appClaimsHelpChar43routeRouteChildren,
  )

interface appClaimsPolicyChar43routeRouteChildren {
  appClaimsPolicyChar43indexRoute: typeof appClaimsPolicyChar43indexRoute
  appClaimsPolicyAllowanceChar43routeRoute: typeof appClaimsPolicyAllowanceChar43routeRoute
  appClaimsPolicyEapChar43routeRoute: typeof appClaimsPolicyEapChar43routeRoute
}

const appClaimsPolicyChar43routeRouteChildren: appClaimsPolicyChar43routeRouteChildren =
  {
    appClaimsPolicyChar43indexRoute: appClaimsPolicyChar43indexRoute,
    appClaimsPolicyAllowanceChar43routeRoute:
      appClaimsPolicyAllowanceChar43routeRoute,
    appClaimsPolicyEapChar43routeRoute: appClaimsPolicyEapChar43routeRoute,
  }

const appClaimsPolicyChar43routeRouteWithChildren =
  appClaimsPolicyChar43routeRoute._addFileChildren(
    appClaimsPolicyChar43routeRouteChildren,
  )

interface appClaimsChar43routeRouteChildren {
  appClaimsChar43indexRoute: typeof appClaimsChar43indexRoute
  appClaimsChar91claimIdChar93Char43routeRoute: typeof appClaimsChar91claimIdChar93Char43routeRoute
  appClaimsHelpChar43routeRoute: typeof appClaimsHelpChar43routeRouteWithChildren
  appClaimsNewChar43routeRoute: typeof appClaimsNewChar43routeRoute
  appClaimsPolicyChar43routeRoute: typeof appClaimsPolicyChar43routeRouteWithChildren
  appClaimsSetupChar43routeRoute: typeof appClaimsSetupChar43routeRoute
}

const appClaimsChar43routeRouteChildren: appClaimsChar43routeRouteChildren = {
  appClaimsChar43indexRoute: appClaimsChar43indexRoute,
  appClaimsChar91claimIdChar93Char43routeRoute:
    appClaimsChar91claimIdChar93Char43routeRoute,
  appClaimsHelpChar43routeRoute: appClaimsHelpChar43routeRouteWithChildren,
  appClaimsNewChar43routeRoute: appClaimsNewChar43routeRoute,
  appClaimsPolicyChar43routeRoute: appClaimsPolicyChar43routeRouteWithChildren,
  appClaimsSetupChar43routeRoute: appClaimsSetupChar43routeRoute,
}

const appClaimsChar43routeRouteWithChildren =
  appClaimsChar43routeRoute._addFileChildren(appClaimsChar43routeRouteChildren)

interface appEapChar43routeRouteChildren {
  appEapChar43indexRoute: typeof appEapChar43indexRoute
  appEapListingsListingIdChar43routeRoute: typeof appEapListingsListingIdChar43routeRoute
  appEapPurchaseChar43routeRoute: typeof appEapPurchaseChar43routeRoute
  appEapRequestChar43routeRoute: typeof appEapRequestChar43routeRoute
}

const appEapChar43routeRouteChildren: appEapChar43routeRouteChildren = {
  appEapChar43indexRoute: appEapChar43indexRoute,
  appEapListingsListingIdChar43routeRoute:
    appEapListingsListingIdChar43routeRoute,
  appEapPurchaseChar43routeRoute: appEapPurchaseChar43routeRoute,
  appEapRequestChar43routeRoute: appEapRequestChar43routeRoute,
}

const appEapChar43routeRouteWithChildren =
  appEapChar43routeRoute._addFileChildren(appEapChar43routeRouteChildren)

interface appMessagesChar43routeRouteChildren {
  appMessagesChar43indexRoute: typeof appMessagesChar43indexRoute
  appMessagesConversationIdChar43routeRoute: typeof appMessagesConversationIdChar43routeRoute
}

const appMessagesChar43routeRouteChildren: appMessagesChar43routeRouteChildren =
  {
    appMessagesChar43indexRoute: appMessagesChar43indexRoute,
    appMessagesConversationIdChar43routeRoute:
      appMessagesConversationIdChar43routeRoute,
  }

const appMessagesChar43routeRouteWithChildren =
  appMessagesChar43routeRoute._addFileChildren(
    appMessagesChar43routeRouteChildren,
  )

interface appPurchasesChar43routeRouteChildren {
  appPurchasesChar43indexRoute: typeof appPurchasesChar43indexRoute
  appPurchasesPurchaseIdCancelChar43routeRoute: typeof appPurchasesPurchaseIdCancelChar43routeRoute
  appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute: typeof appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute
}

const appPurchasesChar43routeRouteChildren: appPurchasesChar43routeRouteChildren =
  {
    appPurchasesChar43indexRoute: appPurchasesChar43indexRoute,
    appPurchasesPurchaseIdCancelChar43routeRoute:
      appPurchasesPurchaseIdCancelChar43routeRoute,
    appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute:
      appPurchasesSubscriptionsSubscriptionIdCancelChar43routeRoute,
  }

const appPurchasesChar43routeRouteWithChildren =
  appPurchasesChar43routeRoute._addFileChildren(
    appPurchasesChar43routeRouteChildren,
  )

interface appResourcesChar43routeRouteChildren {
  appResourcesChar43indexRoute: typeof appResourcesChar43indexRoute
  appResourcesResourceIdChar43routeRoute: typeof appResourcesResourceIdChar43routeRoute
}

const appResourcesChar43routeRouteChildren: appResourcesChar43routeRouteChildren =
  {
    appResourcesChar43indexRoute: appResourcesChar43indexRoute,
    appResourcesResourceIdChar43routeRoute:
      appResourcesResourceIdChar43routeRoute,
  }

const appResourcesChar43routeRouteWithChildren =
  appResourcesChar43routeRoute._addFileChildren(
    appResourcesChar43routeRouteChildren,
  )

interface appSettingsChar43routeRouteChildren {
  appSettingsChar43indexDotlazyRoute: typeof appSettingsChar43indexDotlazyRoute
}

const appSettingsChar43routeRouteChildren: appSettingsChar43routeRouteChildren =
  {
    appSettingsChar43indexDotlazyRoute: appSettingsChar43indexDotlazyRoute,
  }

const appSettingsChar43routeRouteWithChildren =
  appSettingsChar43routeRoute._addFileChildren(
    appSettingsChar43routeRouteChildren,
  )

interface appTopUpChar43routeRouteChildren {
  appTopUpChar43indexRoute: typeof appTopUpChar43indexRoute
  appTopUpCompleteChar43routeRoute: typeof appTopUpCompleteChar43routeRoute
  appTopUpCheckoutChar43routeRoute: typeof appTopUpCheckoutChar43routeRoute
}

const appTopUpChar43routeRouteChildren: appTopUpChar43routeRouteChildren = {
  appTopUpChar43indexRoute: appTopUpChar43indexRoute,
  appTopUpCompleteChar43routeRoute: appTopUpCompleteChar43routeRoute,
  appTopUpCheckoutChar43routeRoute: appTopUpCheckoutChar43routeRoute,
}

const appTopUpChar43routeRouteWithChildren =
  appTopUpChar43routeRoute._addFileChildren(appTopUpChar43routeRouteChildren)

interface appWalletChar43routeRouteChildren {
  appWalletChar43indexRoute: typeof appWalletChar43indexRoute
  appWalletExpiringChar43routeRoute: typeof appWalletExpiringChar43routeRoute
}

const appWalletChar43routeRouteChildren: appWalletChar43routeRouteChildren = {
  appWalletChar43indexRoute: appWalletChar43indexRoute,
  appWalletExpiringChar43routeRoute: appWalletExpiringChar43routeRoute,
}

const appWalletChar43routeRouteWithChildren =
  appWalletChar43routeRoute._addFileChildren(appWalletChar43routeRouteChildren)

interface appChar43routeRouteChildren {
  appClaimsChar43routeRoute: typeof appClaimsChar43routeRouteWithChildren
  appEapChar43routeRoute: typeof appEapChar43routeRouteWithChildren
  appMessagesChar43routeRoute: typeof appMessagesChar43routeRouteWithChildren
  appPurchasesChar43routeRoute: typeof appPurchasesChar43routeRouteWithChildren
  appResourcesChar43routeRoute: typeof appResourcesChar43routeRouteWithChildren
  appSettingsChar43routeRoute: typeof appSettingsChar43routeRouteWithChildren
  appTopUpChar43routeRoute: typeof appTopUpChar43routeRouteWithChildren
  appWalletChar43routeRoute: typeof appWalletChar43routeRouteWithChildren
  appFavouritesIndexRoute: typeof appFavouritesIndexRoute
  appHomeIndexRoute: typeof appHomeIndexRoute
  appMarketplaceChar43indexRoute: typeof appMarketplaceChar43indexRoute
  appEapReviewsChar43routeRoute: typeof appEapReviewsChar43routeRoute
  appMarketplaceListingsListingIdChar43routeRoute: typeof appMarketplaceListingsListingIdChar43routeRoute
  appMarketplaceSuppliersSupplierIdChar43routeRoute: typeof appMarketplaceSuppliersSupplierIdChar43routeRoute
  appMarketplacePurchaseChar43routeRoute: typeof appMarketplacePurchaseChar43routeRoute
  appMarketplaceRequestChar43routeRoute: typeof appMarketplaceRequestChar43routeRoute
}

const appChar43routeRouteChildren: appChar43routeRouteChildren = {
  appClaimsChar43routeRoute: appClaimsChar43routeRouteWithChildren,
  appEapChar43routeRoute: appEapChar43routeRouteWithChildren,
  appMessagesChar43routeRoute: appMessagesChar43routeRouteWithChildren,
  appPurchasesChar43routeRoute: appPurchasesChar43routeRouteWithChildren,
  appResourcesChar43routeRoute: appResourcesChar43routeRouteWithChildren,
  appSettingsChar43routeRoute: appSettingsChar43routeRouteWithChildren,
  appTopUpChar43routeRoute: appTopUpChar43routeRouteWithChildren,
  appWalletChar43routeRoute: appWalletChar43routeRouteWithChildren,
  appFavouritesIndexRoute: appFavouritesIndexRoute,
  appHomeIndexRoute: appHomeIndexRoute,
  appMarketplaceChar43indexRoute: appMarketplaceChar43indexRoute,
  appEapReviewsChar43routeRoute: appEapReviewsChar43routeRoute,
  appMarketplaceListingsListingIdChar43routeRoute:
    appMarketplaceListingsListingIdChar43routeRoute,
  appMarketplaceSuppliersSupplierIdChar43routeRoute:
    appMarketplaceSuppliersSupplierIdChar43routeRoute,
  appMarketplacePurchaseChar43routeRoute:
    appMarketplacePurchaseChar43routeRoute,
  appMarketplaceRequestChar43routeRoute: appMarketplaceRequestChar43routeRoute,
}

const appChar43routeRouteWithChildren = appChar43routeRoute._addFileChildren(
  appChar43routeRouteChildren,
)

interface Char43authRouteChildren {
  appChar43routeRoute: typeof appChar43routeRouteWithChildren
  mergeAccountChar43routeRoute: typeof mergeAccountChar43routeRoute
}

const Char43authRouteChildren: Char43authRouteChildren = {
  appChar43routeRoute: appChar43routeRouteWithChildren,
  mergeAccountChar43routeRoute: mergeAccountChar43routeRoute,
}

const Char43authRouteWithChildren = Char43authRoute._addFileChildren(
  Char43authRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  Char43indexRoute: Char43indexRoute,
  Char43authRoute: Char43authRouteWithChildren,
  demoChar43routeRoute: demoChar43routeRoute,
  forgotPasswordChar43routeRoute: forgotPasswordChar43routeRoute,
  newAccountChar43routeRoute: newAccountChar43routeRoute,
  nominateChar43routeRoute: nominateChar43routeRoute,
  signInChar43routeRoute: signInChar43routeRoute,
  giftActivateChar43routeRoute: giftActivateChar43routeRoute,
  invitationActivateChar43routeRoute: invitationActivateChar43routeRoute,
  policiesTermsChar43routeRoute: policiesTermsChar43routeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
